import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

// Counts down to the daily order cut-off (next local midnight) for 2-day delivery.
const useCutoffCountdown = () => {
  const [t, setT] = useState({ h: 0, m: 0, s: 0 });
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const diff = Math.max(0, end - now);
      setT({
        h: Math.floor(diff / 3.6e6),
        m: Math.floor((diff % 3.6e6) / 6e4),
        s: Math.floor((diff % 6e4) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return t;
};

const UrgencyBanner = () => {
  const { h, m, s } = useCutoffCountdown();
  return (
    <div
      className="fixed inset-x-0 top-0 z-[95] glass border-b border-[#F3E5AB]/12"
      data-testid="urgency-banner"
    >
      <div className="mx-auto flex h-10 max-w-7xl items-center justify-center gap-2 px-4 text-center">
        <Zap className="h-3.5 w-3.5 shrink-0 text-[#D4AF37]" fill="#D4AF37" strokeWidth={0} />
        <span className="hidden font-sans text-xs tracking-wide text-[#E8E2D0] sm:inline">
          ⚡ Guaranteed 2-Day Express Delivery Across Major Cities | Powered by Consortium Gifts (26+ Years Legacy)
        </span>
        <span className="font-sans text-xs tracking-wide text-[#A9B0C2] sm:hidden">⚡ 2-Day Express · Consortium Gifts</span>
        <span className="hidden font-sans text-xs tracking-wide text-[#A9B0C2] lg:inline">· Order within</span>
        <span
          className="hidden font-sans text-xs font-semibold tabular-nums tracking-widest text-[#F3E5AB] lg:inline"
          data-testid="countdown-timer"
        >
          {pad(h)}:{pad(m)}:{pad(s)}
        </span>
        <span className="relative ml-1 flex h-2 w-2">
          <span className="pulse-dot absolute inline-flex h-full w-full rounded-full bg-[#D4AF37]" />
        </span>
      </div>
    </div>
  );
};

export default UrgencyBanner;
